import React from 'react';
import './Footer.css';
import logo from '../assets/images/koreansir-logo.webp';

export default function Footer({ onNavigate }) {
  return (
    <footer className="footer-shell" lang="si">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-info">
            <img src={logo} alt="Korean Sir" className="footer-logo" />
            <p className="footer-bio">
              කොරියානු සිහිනය ජය ගැනීමට වෙර දරන දහස් සංඛ්‍යාත ශ්‍රී ලාංකික තරුණ තරුණියන් සඳහා නිවැරදි මඟ පෙන්වීම සහ උසස් ම අධ්‍යාපන පහසුකම් සපයන ප්‍රමුඛතම වේදිකාව.
            </p>
            <div className="footer-socials">
              <a
                href="https://web.facebook.com/koreansir1"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>
            </div>
          </div>

          <div className="footer-nav-groups">
            <div className="footer-nav-col">
              <h4 className="footer-title">ප්‍රධාන මෙනුව</h4>
              <ul className="footer-links">
                <li><a href="/" onClick={(e) => { e.preventDefault(); onNavigate?.('/'); }}>මුල් පිටුව</a></li>
                <li><a href="/before-korea" onClick={(e) => { e.preventDefault(); onNavigate?.('/before-korea'); }}>කොරියාවට යාමට පෙර</a></li>
                <li><a href="/language" onClick={(e) => { e.preventDefault(); onNavigate?.('/language'); }}>භාෂා හුරුව</a></li>
                <li><a href="/news" onClick={(e) => { e.preventDefault(); onNavigate?.('/news'); }}>කොරියන් තතු</a></li>
              </ul>
            </div>
            
            <div className="footer-nav-col">
              <h4 className="footer-title">සහය</h4>
              <ul className="footer-links">
                <li><a href="/faq" onClick={(e) => { e.preventDefault(); onNavigate?.('/faq'); }}>ප්‍රශ්න හා පිළිතුරු</a></li>
                <li><a href="/contact" onClick={(e) => { e.preventDefault(); onNavigate?.('/contact'); }}>අමතන්න</a></li>
                <li><a href="/privacy-policy/" onClick={(e) => { e.preventDefault(); onNavigate?.('/privacy-policy/'); }}>Privacy Policy</a></li>
                <li><a href="/refund-policy/" onClick={(e) => { e.preventDefault(); onNavigate?.('/refund-policy/'); }}>Refund Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <p className="copyright">
              &copy; {new Date().getFullYear()} Korean Sir. All Rights Reserved. Developed By <a href="https://techseya.lk" target="_blank" rel="noopener noreferrer">Techseya</a> | Powered by Aoura Network
            </p>
            <div className="footer-legal">
              <a href="/terms-conditions/" onClick={(e) => { e.preventDefault(); onNavigate?.('/terms-conditions/'); }}>Terms</a>
              <a href="/privacy-policy/" onClick={(e) => { e.preventDefault(); onNavigate?.('/privacy-policy/'); }}>Privacy</a>
              <a href="/refund-policy/" onClick={(e) => { e.preventDefault(); onNavigate?.('/refund-policy/'); }}>Refund</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
